import { APIMethod, fetchData } from "@client";

export async function getShareLinkQuery(projectUuid) {
  const res = await fetchData(`/project/link/${projectUuid}`, APIMethod.GET);

  return res.results.link;
}
